/**
 * Marketing Strategy — API
 *
 * Sprint 3 · Project Symphony
 *
 * Deterministic endpoints. No AI provider is invoked on either side.
 */
import { http } from "@/shared/api/http";
import type { BlueprintResponse, EventsResponse } from "./types";

export const compileStrategy = (blueprintId: string): Promise<BlueprintResponse> =>
  http<BlueprintResponse>(`/orchestration/blueprints/${blueprintId}/compile`, {
    method: "POST",
  });

export const getStrategy = (blueprintId: string): Promise<BlueprintResponse> =>
  http<BlueprintResponse>(`/orchestration/blueprints/${blueprintId}`);

export const approveStrategy = (blueprintId: string): Promise<BlueprintResponse> =>
  http<BlueprintResponse>(`/orchestration/blueprints/${blueprintId}/approve`, {
    method: "POST",
  });

export const listEvents = (blueprintId: string): Promise<EventsResponse> =>
  http<EventsResponse>(`/orchestration/blueprints/${blueprintId}/events`);
